/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from "react";
import { Form, InputGroup } from "react-bootstrap";
import * as S from "../../styles";

export interface ICheckBoxProps {
  id: string;
  label?: string;
  value?: any[];
  readOnly?: boolean;
  errorText?: string;
  direction?: "horizontal" | "vertical";
  options?: { id: string; label: string }[];
  required?: boolean;
  placeholder?: string;
  labelColor?: string;
  onCompChange?(id: string, payload: any): void;
  hasError?: boolean;
}

export const CheckBox = ({
  id,
  label,
  errorText,
  value,
  required,
  options,
  onCompChange,
  labelColor,
  hasError,
  direction,
  readOnly
}: ICheckBoxProps) => {
  const [item, setItem] = useState({ textValue: value ?? [] });
  const [isInvalid, setInvalid] = useState(false);

  useEffect(() => {
    if (hasError) {
      setInvalid(true);
    }
  }, [hasError]);
  // const [textValue, setTextValue] = useState(value ?? "");
  const onChange = (id: string, e: any) => {
    const _textValue = [...(textValue || [])];
    const index = _textValue.indexOf(e?.target?.value);
    if (index !== -1) {
      _textValue.splice(index, 1);
    } else {
      _textValue.push(e?.target?.value);
    }
    setItem(prevState => ({
      ...prevState,
      textValue: _textValue
    }));
    onCompChange && onCompChange(id, _textValue);
  };
  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: "red" }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const _renderErrorTextIf = () => {
    if (hasError && errorText) {
      return (
        <S.FeedbackOtherLabel type="tooltip">
          {errorText}
        </S.FeedbackOtherLabel>
      );
    }
    return null;
  };
  const { textValue } = item;
  const Comp = direction === "vertical" ? InputGroup : React.Fragment;
  return (
    <>
      <Form.Group id={id} className="mb-4 formgroup">
        {_renderLabelIf()}
        <Comp>
          <div className="row">
            {options?.slice(0, Math.ceil(options.length / 2)).map((option, index) => (
              <div className="col-12" key={`check-box-option-${option?.id}-${index}`}>
                <Form.Check
                  className="formcheck form-check-select mt-1 mb-1"
                  type={"checkbox"}
                  label={option?.label}
                  aria-label={`check-${index + 1}`}
                  value={option.id}
                  onChange={onChange.bind(null, id)}
                  checked={textValue?.includes(option.id)}
                  isInvalid={isInvalid}
                  readOnly={readOnly}
                />
              </div>
            ))}
          </div>
          <div className="row">
            {options?.slice(Math.ceil(options.length / 2)).map((option, index) => (
              <div className="col-12" key={`check-box-option-${option?.id}-${index}`}>
                <Form.Check
                  className="formcheck form-check-select mt-1 mb-1"
                  type={"checkbox"}
                  label={option?.label}
                  aria-label={`check-${index + 1}`}
                  value={option.id}
                  onChange={onChange.bind(null, id)}
                  checked={textValue?.includes(option.id)}
                  isInvalid={isInvalid}
                  readOnly={readOnly}
                />
              </div>
            ))}
          </div>
          {direction === "horizontal" ? (
            _renderErrorTextIf()
          ) : (
            <InputGroup>{_renderErrorTextIf()}</InputGroup>
          )}
        </Comp>
      </Form.Group>
    </>
  );
};

CheckBox.defaultProps = {
  direction: "vertical",
  required: false,
  rootColor: "grey",
  pointColor: "#000000",
  hasError: false,
  readOnly: false
};
